import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../../../common/html/element'
import { MAX_CONDITION } from '../../../../common/constant'
import { ErrorMessage } from '../../../../common/errorMessage'
import { getCurrentTime } from '../../../../common/helper'
import { Input } from '../../../../common/input'
import { selectScreeningIndicatorById } from '../../../../common/store/slice'
import { changeCriteria, selectCriteria } from '../../../store/slice'
import { DeleteAddButtons } from '../deleteAddButtons'
import classes from './index.module.scss'
import { TextBoxSuggestion } from './TextBoxSuggestion'

export const TextAreaItem = ({
  criteriaGroup,
  screeningIndicatorId,
  conditionId,
  hasAddBtn,
  conditionsLength,
  isNumber,
}) => {
  const dispatch = useDispatch()

  const timeoutRef = useRef()

  const suggestionLink = useSelector(
    selectScreeningIndicatorById(screeningIndicatorId, 'sugesstionLink'),
  )
  const maxMultiple =
    useSelector(
      selectScreeningIndicatorById(screeningIndicatorId, 'maxMultiple'),
    ) || MAX_CONDITION

  const conditionData = useSelector(
    selectCriteria([criteriaGroup, screeningIndicatorId, 'data', conditionId]),
  )

  const [isShowMaxMessage, setIsShowMaxMessage] = useState(false)

  const onAddBtnClick = () => {
    if (conditionsLength >= maxMultiple) {
      setIsShowMaxMessage(true)
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => {
        setIsShowMaxMessage(false)
      }, 3000)
      return
    }

    const id = getCurrentTime()
    dispatch(
      changeCriteria({
        path: [criteriaGroup, screeningIndicatorId, 'data', id],
        data: { id, value: '' },
      }),
    )
  }

  const onDeleteBtnClick = () => {
    if (conditionsLength === 1) {
      dispatch(
        changeCriteria({
          path: [
            criteriaGroup,
            screeningIndicatorId,
            'data',
            conditionId,
            'value',
          ],
          data: '',
        }),
      )
    } else {
      dispatch(
        changeCriteria({
          path: [criteriaGroup, screeningIndicatorId, 'data', conditionId],
          data: undefined,
        }),
      )
    }
  }

  const resetError = () => {
    if (conditionData.error) {
      dispatch(
        changeCriteria({
          path: [
            criteriaGroup,
            screeningIndicatorId,
            'data',
            conditionId,
            'error',
          ],
          data: undefined,
        }),
      )
    }
  }

  const onInputChange = (value) => {
    resetError()
    dispatch(
      changeCriteria({
        path: [
          criteriaGroup,
          screeningIndicatorId,
          'data',
          conditionId,
          'value',
        ],
        data: value,
      }),
    )
  }

  const renderInput = (props) => {
    return (
      <Input
        isNumber={isNumber}
        value={conditionData.value}
        autoFocus
        onChange={(value) => {
          props?.showDropdown && props.showDropdown()
          onInputChange(value)
        }}
        wrapperClassname="flex1 minW0"
        onKeyDown={(event) => {
          //Prevent keyboard arrow up and down
          if (event.keyCode === 38 || event.keyCode === 40) {
            event.preventDefault()
          }
          if (event.key === 'Tab') {
            props.hideDropdown && props.hideDropdown()
          }
        }}
      />
    )
  }

  return (
    <>
      <Element className={classes.area}>
        {suggestionLink ? (
          <TextBoxSuggestion
            renderInput={renderInput}
            suggestionLink={suggestionLink}
            keyword={conditionData.value}
            onChoose={onInputChange}
          />
        ) : (
          renderInput()
        )}
        <DeleteAddButtons
          showAddBtn={hasAddBtn}
          onAddBtnClick={onAddBtnClick}
          onDeleteBtnClick={onDeleteBtnClick}
        />
      </Element>
      {conditionData.error && <ErrorMessage value="screening.REQUIRED_MESS" />}
      {hasAddBtn && isShowMaxMessage && (
        <ErrorMessage
          value="screening.MAX_CONDITION_MESS"
          max={maxMultiple}
          className="mt1"
        />
      )}
    </>
  )
}
